// @noflow
import React from 'react'

import {
  ICON_COLOURS,
  IconColours
} from '@/components/elements/atoms/Icon/Icon'

import STYLES from './star.module.sass'

type StarTypes = 'filled' | 'half' | 'empty'

type Props = {
  size: number
  accentColour: IconColours
  width?: number | string
  starType?: StarTypes
  responsive?: boolean // size scales on desktop from 2.8rem to 4.6rem
}

const Star = ({
  size,
  accentColour,
  width,
  starType = 'filled',
  responsive = false
}: Props): JSX.Element => {
  const starTypeFill = (): string => {
    switch (starType) {
      case 'filled': {
        return ICON_COLOURS[accentColour]
      }
      case 'half': {
        return 'url(#gradient)'
      }
      case 'empty': {
        return 'transparent'
      }
    }
  }

  return (
    <svg
      height={size}
      viewBox="0 0 21 21"
      width={width || '100%'}
      className={`${STYLES.star} ${responsive ? STYLES.responsive : ''}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {starType === 'half' && (
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="50%"
              style={{ stopColor: ICON_COLOURS[accentColour], stopOpacity: 1 }}
            />
            <stop
              offset="50%"
              style={{ stopColor: 'transparent', stopOpacity: 1 }}
            />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6904 17.3437C16.8654 18.6104 16.6655 19.0318 16.6655 19.0318C16.7568 19.1217 16.8482 19.2115 16.8482 19.3014C16.9395 19.4811 16.9395 19.571 16.7568 19.6608C16.6654 19.7507 16.5741 19.7507 16.4827 19.7507C16.3 19.6608 16.2086 19.6608 16.0259 19.6608C15.9346 19.6608 15.8432 19.6608 15.6605 19.7507C15.5691 19.8406 15.4778 19.8406 15.4778 19.7507C15.2037 19.571 14.9296 19.571 14.6555 19.3912C14.1987 19.2115 13.8333 18.9419 13.3765 18.7622C12.9197 18.5825 12.6456 18.4028 12.1888 18.1332C12.0061 18.0433 11.9147 17.9535 11.9147 17.8636L11.732 17.6839C11.4579 17.5041 11.1838 17.3244 10.8184 17.1447C10.727 17.0548 10.727 17.0548 10.6357 17.0548H10.5443C10.3616 17.1447 10.2702 17.2346 10.0875 17.2346C9.53933 17.4143 9.08253 17.594 8.62573 17.8636C8.16893 18.0433 7.71212 18.223 7.16396 18.4926C6.70716 18.6723 6.25036 18.8521 5.79355 19.1217C5.51947 19.2115 5.15403 19.3912 4.78859 19.4811H4.69723C4.42315 19.3912 4.24042 19.571 4.0577 19.6608C3.87498 19.7507 3.69226 19.8406 3.50954 19.8406C3.32682 19.9304 3.23546 20.0203 3.05274 20.1101C2.96138 20.2 2.96138 20.2 2.87002 20.2C2.6873 20.2 2.59594 20.1101 2.59594 19.9304C2.59594 19.7507 2.59594 19.4811 2.77866 19.3014C2.87002 19.1217 4.42315 14.359 4.51451 14.1793C4.69723 13.9097 4.87995 13.5502 5.06267 13.2806L5.33675 13.0111C5.51947 12.8313 5.42811 12.6516 5.15403 12.5617C4.87995 12.4719 4.78859 12.382 4.60587 12.2922C4.51451 12.2023 4.51451 12.2023 4.42315 12.2023C4.24042 12.1124 3.96634 12.0226 3.78362 11.753C3.69226 11.6631 3.6009 11.6631 3.6009 11.5733C3.23546 11.2138 0.951447 8.60783 0.860087 8.51797C0.677366 8.24839 0.403285 7.88894 0.129203 7.70921C0.0378428 7.61935 -0.0535177 7.52949 0.0378427 7.34977V7.25991C0.0378427 7.08018 0.311924 6.90046 0.494645 7.08018C0.677366 7.17004 0.860087 7.17004 1.04281 7.17004C1.49961 7.17004 1.95641 7.08018 2.41322 7.08018C2.6873 7.08018 3.05274 6.99032 3.41818 6.99032C3.87498 6.99032 4.33179 6.99032 4.69723 6.90046H5.70219C5.88491 6.90046 6.06763 6.99032 6.25035 7.08018C6.34172 7.17004 6.43308 7.17004 6.52444 6.99032C6.6158 6.8106 6.70716 6.63087 6.79852 6.54101C6.98124 6.00184 7.25532 5.46267 7.43804 4.9235C7.62076 4.47419 7.89484 3.93502 8.16893 3.39585C8.26029 3.21613 8.35165 2.94654 8.44301 2.76682C8.53437 2.58709 8.71709 2.31751 8.89981 2.04792C8.99117 1.95806 8.99117 1.8682 9.08253 1.8682C9.17389 1.8682 9.17389 1.77834 9.17389 1.77834C9.26525 1.59861 9.35661 1.41889 9.44797 1.14931C9.53933 1.05944 9.53933 1.05944 9.53933 0.969582C9.63069 0.87972 9.63069 0.789859 9.72205 0.87972C9.81341 0.969582 9.90477 0.969582 9.90477 1.05944C9.90477 1.0707 9.92915 1.10735 9.97486 1.16939C9.94763 0.980079 10.1089 0.699997 10.2702 0.699997C10.3616 0.699997 10.4529 0.789859 10.5443 0.87972C10.9097 1.41889 11.0925 1.95806 11.3665 2.49723C11.4579 2.67696 11.5493 2.85668 11.5493 3.0364C11.6406 3.12626 11.6406 3.12626 11.732 3.12626H11.9147C12.0061 3.12626 12.0061 3.21613 12.0974 3.30599C12.1888 3.57557 12.4629 3.93502 12.6456 4.20461C12.8283 4.38433 12.9197 4.56405 13.011 4.83364C13.1024 4.9235 13.1024 5.01336 13.1938 5.10322L13.2851 5.19309C13.2851 5.37281 13.3765 5.37281 13.5592 5.37281C14.016 5.46267 14.4728 5.46267 14.9296 5.55253C15.3864 5.64239 15.9346 5.73226 16.3914 5.73226C16.7568 5.82212 17.1223 5.82212 17.4877 5.91198C17.8531 6.00184 18.2186 6.00184 18.584 6.0917L20.2285 6.36129C20.3199 6.45115 20.5026 6.45115 20.594 6.36129C20.6853 6.27143 20.7767 6.36129 20.9594 6.27143C20.9594 6.36129 21.0508 6.45115 20.9594 6.45115C20.868 6.54101 20.868 6.63087 20.868 6.72074C20.7767 6.8106 20.7767 6.90046 20.6853 6.90046C20.5026 6.99032 20.4112 6.99032 20.3199 7.17004C20.3199 7.25991 20.2285 7.25991 20.2285 7.34977C20.0458 7.43963 19.8631 7.61935 19.7717 7.79908C19.6803 7.88894 19.589 7.9788 19.4976 7.9788C19.1322 8.24839 18.7667 8.60783 18.4013 8.87742C18.2186 9.05714 17.9445 9.23687 17.7618 9.41659C17.5791 9.68617 17.305 9.95576 17.0309 10.1355C16.8482 10.3152 16.6654 10.4051 16.5741 10.4949C16.2086 10.7645 15.9346 11.124 15.5691 11.4834L15.4778 11.5733C15.7518 11.9327 15.8432 12.382 15.9346 12.8313C16.0259 13.1908 16.1173 13.5502 16.3 13.9097C16.3914 14.0894 16.3914 14.1793 16.3914 14.4488C16.4827 14.8982 16.6654 15.4373 16.7568 15.8866C16.8482 16.1562 16.8482 16.5157 16.8482 16.8751C16.8482 17.1479 16.7956 17.3171 16.6904 17.3437Z"
        fill={starTypeFill()}
        stroke={ICON_COLOURS[accentColour]}
      />
    </svg>
  )
}

export type { StarTypes }
export default Star
